import React from 'react'
import { NavDropdown, Nav } from 'react-bootstrap'
import { PersonFill } from 'react-bootstrap-icons'
import useCurrentUser from '../../../hooks/use-current-user'
import { useAuth0 } from '@auth0/auth0-react'

const UserDropdownMenu = () => {
    const { loginWithRedirect, logout } = useAuth0()
    const { currentUser, isAuthorized, isVerified } = useCurrentUser()

    if(!currentUser) {
        return (
            <Nav.Link href='#' onClick={loginWithRedirect}>Sign In</Nav.Link>
        )
    }
    if (!isAuthorized || !isVerified) {
        return (
            <Nav.Link href='#' onClick={() => logout({ returnTo: window.location.origin })}>Sign Out</Nav.Link>
        )
    }
    return (
        <React.Fragment>
            <NavDropdown title={<PersonFill />} alignRight>
                <NavDropdown.Item disabled>{currentUser ? currentUser.email : 'UNKNOWN'}</NavDropdown.Item>  
                <NavDropdown.Divider />
                {currentUser && <NavDropdown.Item onClick={() => logout({ returnTo: window.location.origin })}>Sign Out</NavDropdown.Item>}
            </NavDropdown>
        </React.Fragment>
    )
}

export default UserDropdownMenu